<div class="summary-panel-container1">
  <mat-card class="summary-item1 pointer">
    <mat-card-content> 
        <div class="flex-row-container">
          <div class="flex-col-container wd-70">
            <span class="blueText20 text-truncate">{{client.clientname}}</span>
            <span *ngIf="client.role==='Primary' || client.role==='Secondary'" class="font15">Gender: <span class="blueText16">{{client.gender==='M'?'Male':'Female'}}</span></span>              
            <span *ngIf="client.dob" class="font15">Date of Birth: <span class="blueText16">{{client.dob  | date:'MM/dd/yyyy'}}</span></span>
            <span *ngIf="client.age" class="font15">Age: <span class="blueText16">{{client.age}}</span></span>
            <span *ngIf="client.role==='Primary' || client.role==='Secondary'" class="font15">Retirment Age: <span class="blueText16">{{client.retAge}}</span></span>      
            <span *ngIf="client.role==='Primary' || client.role==='Secondary'" class="font15">Plan End Age: <span class="blueText16">{{client.endAge}}</span></span>      
            <span *ngIf="client.role==='Primary' || client.role==='Secondary'" class="font15 text-truncate">State of Residence: <span class="blueText16">{{client.stateOfResi}}</span></span>            
          </div>
          <div class="flex-col-end m-l25 wd-30">            
            <span class="blueText18 flex-1 ">
              {{client.role==='Primary'?'Client':(client.role==='Secondary'?'Spouse': client.role)}}

            </span>
            <!-- <span class="blueText22">Employment Income: $300,787</span> -->
            <!-- <span class="font16">Employed</span> -->

            
            <div *ngIf="allowToChange" class="flex-row-container m-t5">
              <mat-icon class="font20 m-l10" *ngIf="client.role!=='Primary'" (click)="removeClient();" matTooltipPosition ="below" matTooltipClass="tooltip" matTooltip="Remove">delete</mat-icon>
              <mat-icon class="font20 m-l10" *ngIf="client.role==='Primary' || client.role==='Secondary'"  (click)="editClient();" matTooltipPosition ="below" matTooltipClass="tooltip" matTooltip="Edit">edit</mat-icon>              
            </div>
          </div>          
          
        </div>        
    </mat-card-content>
  </mat-card>
</div>


